import { Button } from '@cognite/cogs.js';
import React, { useCallback } from 'react';
import type { ActionButtonGroupProps } from 'types';
import { ReviewerResponse } from 'types';
import CommentStateFlag from '../CommentStateFlag/CommentStateFlag';

const ActionButtonGroup = ({
  userRole,
  parentComment,
  hasChildComments,
  setChecked,
  onSubmitResponse,
  onRejectResolution,
  onConfirmResolution,
}: ActionButtonGroupProps) => {
  const { metaData } = parentComment;
  const isCompilerResolved = metaData?.isCompilerResolved === 'true';
  const isReviewerConfirmed =
    metaData?.reviewerResponse === ReviewerResponse.Confirmed;
  const isReviewerRejected =
    metaData?.reviewerResponse === ReviewerResponse.Rejected;
  const canSubmitResponse = !isReviewerRejected && hasChildComments;

  const handleEnterResponse = useCallback(() => {
    setChecked(true);
  }, [setChecked]);

  if (userRole === 'compiler') {
    if (isCompilerResolved) return <CommentStateFlag state="resolved" />;
    return (
      <>
        {isReviewerRejected && <CommentStateFlag state="rejected" />}
        <Button type="primary" onClick={handleEnterResponse}>
          Enter Response
        </Button>
        {canSubmitResponse && (
          <Button type="secondary" onClick={onSubmitResponse}>
            Submit Response
          </Button>
        )}
      </>
    );
  }
  if (isReviewerConfirmed) return <CommentStateFlag state="confirmed" />;
  if (isReviewerRejected) return <CommentStateFlag state="rejected" />;
  if (hasChildComments && isCompilerResolved) {
    return (
      <>
        <Button type="destructive" onClick={onRejectResolution}>
          Reject Resolution
        </Button>
        <Button type="secondary" onClick={onConfirmResolution}>
          Confirm Resolution
        </Button>
      </>
    );
  }
  return null;
};

export default ActionButtonGroup;
